import { render } from "./sfScreen.vue?vue&type=template&id=90d66e10"
import script from "./sfScreen.vue?vue&type=script&lang=js"
export * from "./sfScreen.vue?vue&type=script&lang=js"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__